import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

export interface Props {
  label: React.ReactNode
  value: React.ReactNode
  labelColor?: TypographyProps['color']
  valueColor?: TypographyProps['color']
  labelVariant?: TypographyProps['variant']
  valueVariant?: TypographyProps['variant']
}

const LabeledValue: React.SFC<Props> = ({
  label,
  value,
  labelColor,
  valueColor,
  labelVariant,
  valueVariant,
  ...props
}) => (
    <Grid
      alignItems="center"
      direction="column"
      {...props}
      container
    >
      <Typography variant={labelVariant || 'caption'} color={labelColor || 'inherit'}>
        {label}
      </Typography>
      <Typography variant={valueVariant || 'h4'} color={valueColor || 'inherit'}>
        {value}
      </Typography>
    </Grid>
  )

export default LabeledValue
